import $ from 'jquery';
import replaceSubmitButton from "./replaceSubmitButton";
const infoModal = () => {
    document.addEventListener('click', ev => {
        if (ev.target.parentNode.classList.contains('ume-login-trigger')) {
            ev.preventDefault();
            replaceSubmitButton();
            $('#ume-login-modal').modal('show')

        } else return;
    })
}
export default infoModal;